import { createRouter, createWebHistory } from 'vue-router'
import DownloadView from '../views/DownloadView.vue'
import HomeView from '../views/HomeView.vue'
import ManualView from '../views/ManualView.vue'
import PrivacyView from '../views/PrivacyView.vue'
import { appConfig } from '../utils/config'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: `${appConfig.appTitle} - 首页`,
      announcement: '已进入首页',
    },
  },
  {
    path: '/download',
    name: 'download',
    component: DownloadView,
    meta: {
      title: `${appConfig.appTitle} - 下载`,
      announcement: '已进入下载页',
    },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
    meta: {
      title: `${appConfig.appTitle} - 隐私政策`,
      announcement: '已进入隐私政策页',
    },
  },
  {
    path: '/manual',
    name: 'manual',
    component: ManualView,
    meta: {
      title: `${appConfig.appTitle} - 电子说明书`,
      announcement: '已进入电子说明书页',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
